import { Navbar } from "@/components";
import Footer from "@/components/sections/Footer";
import SolutionTemplate from '@/components/SolutionsTemplate';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export async function getServerSideProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
      ])),
    },
  }
}

export default function Retail() {
    return (
        <>
        <Navbar />
        <SolutionTemplate type = "retail"/>
        <Footer />
        </>
    )
}
